import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

/**
 * D2D sales territories (WWM-17508).
 *
 * Territory boundaries render with no UI toggle of their own, so this flag is the only way to
 * turn them off for a tenant — worth remembering if the layer ever misbehaves in production.
 */
export function useD2DTerritoriesEnabled() {
  const d2DTerritories = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.D2DTerritories),
  )

  return d2DTerritories?.enabled ?? false
}
